import { requestApi } from 'api/api'
import { BASE_API_URL } from 'constants/links'
import { CustomerDocumentContent, CustomerDocumentsV2 } from 'types/customers'
import { WithPaginationApiResponse } from 'types/pagination'

export const getCustomerDocumentsV2 = (
  customerReference: string
): Promise<WithPaginationApiResponse<CustomerDocumentsV2[]>> => {
  return requestApi({
    baseUrl: BASE_API_URL,
    url: `/platform/v2/customers/${customerReference}/documents`,
    method: 'GET',
  })
}

export const getCustomerDocumentContent = (
  customerId: string,
  documentId: string
): Promise<CustomerDocumentContent> => {
  return requestApi({
    baseUrl: BASE_API_URL,
    url: `/platform/v2/customers/${customerId}/documents/${documentId}/content`,
    method: 'GET',
  })
}
